<template>
  <div class="files-grid">
    <div v-for="file in files" :key="file.name" class="file-card" :title="file.name">
      <div class="preview">
        <!-- تصاویر -->
        <img v-if="isImage(file)" :src="file.url" :alt="file.url"  />
        
        <!-- ویدیو -->
        <video v-else-if="isVideo(file)" controls :src="file.url"></video>
        
        <!-- فایل‌های صوتی -->
        <audio v-else-if="isAudio(file)" controls :src="file.url"></audio>
        
        <!-- نمایش آیکون برای سایر فایل‌ها -->
        <div v-else class="file-icon">
          📄
        </div>
      </div>
      <!-- <div class="file-name" :title="file.name">{{ file.name }}</div> -->
      <a class="file-name" :href="file.url" :title="file.name" target="_blank">{{ file.name }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilePreviewGrid',
  props: {
    baseFolder: {
      type: String,
      required: true
    },
    filesProp: {  
      type: Array,  
      default: () => []  
    } ,
  },  
  data() {
    return {
      files: [] 
    }
  },
  async created() {
    //debugger;
    // this.$axios.get(`/Folder/list?path=${this.baseFolder}`).then((response) => {
    //     this.files = response.data.data;//this.convertToBigData(response.data.data);      
    // });
    // debugger;
    //  this.files.map((f) => ({
    //   ...f,
    //   url: this.buildUrl(f.name)
    // }));
    
//    const url = `/api/list?path=${encodeURIComponent(this.baseFolder)}`;
//  //  debugger;
// // ارسال درخواست با Axios
const { data } = await this.$axios.get(`/Folder/list?path=${this.baseFolder}`);
//debugger;
// فرض می‌کنیم پاسخ API، آرایه‌ای از اشیاء به شکل:
// [ { name: 'image.jpg', type: 'image/jpeg' }, ... ]
this.files = (Array.isArray(data.data.items) ? data.data.items : []).map(f => ({
  ...f,
  // اگر پاسخ دارای فیلد url نیست، یک URL کامل بسازید
  url: this.buildUrl(  f.name)
}));
    
   },
  methods: {
    buildUrl(name) {
      const base = this.baseFolder.endsWith('/') ? this.baseFolder : this.baseFolder + '/'
      return   "https://test.mmc.ir/" + base + name  //"https://localhost:7132/"
    },
    isImage(f) {
      return f.type && f.type.startsWith('image/')
    },
    isVideo(f) {
      return f.type && f.type.startsWith('video/')
    },
    isAudio(f) {
      return f.type && f.type.startsWith('audio/')
    }
  },
  // expose computed-like helpers via instance properties
  // یا به‌سادگی از methods در الگوی قالب استفاده می‌کنیم
  computed: {
  // processedFiles() {
  //   // فرض: this.filesProp ممکن است آرایه باشد
  //   const list = Array.isArray(this.filesProp) ? this.filesProp : [];
  //   return list.map((f) => ({
  //     ...f,
  //     url: this.buildUrl(f.name)
  //   }));
  // }
},
  // قالب را می‌توانید از طریق گزینه‌های مخصوص پروپ‌ها گسترش دهید
}
</script>

<style scoped>
.files-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
  direction:rtl;
}
.file-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px;
  background: #fff;
  direction:rtl;
}
.preview {
  width: 100%;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #f8f9fa;
  border-radius: 6px;
}
.preview img, .preview video, .preview audio {
  max-width: 100%;
  max-height: 100%;
}
.file-name {
  margin-top: 6px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.file-icon {
  font-size: 40px;
  line-height: 1;
}
</style>